class Customdrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#customDrawer-Overlay').addEventListener('click', this.close.bind(this));
     this.querySelector('#customDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    // const cartLink = document.querySelector('#cart-icon-bubble');
    // const cartLink_mobile = document.querySelector('#mobile-cart-icon-bubble');

    // if (!cartLink && !cartLink_mobile) return;

    //  if(cartLink){
    //       cartLink.setAttribute('role', 'button');
    //       cartLink.setAttribute('aria-haspopup', 'dialog');
    //       cartLink.addEventListener('click', (event) => {
    //         event.preventDefault();
    //         this.open(cartLink);
    //       });
    //       cartLink.addEventListener('keydown', (event) => {
    //         if (event.code.toUpperCase() === 'SPACE') {
    //           event.preventDefault();
    //           this.open(cartLink);
    //         }
    //       });
    //     }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

}

customElements.define('custom-drawer', Customdrawer);


function CustomdrawerOpen() {
    const custom_drawer = document.querySelector('custom-drawer') || null;
    if(custom_drawer.classList.contains('active')) return;
    if(custom_drawer) custom_drawer.open();
}